export const navbar = {
  logo: {
    height: "3.5rem",
  },
};

export const footer = {
  logo: { maxHeight: "3.5rem" },
};
